import axios from 'axios'

export default {
    getById(id) {
        return axios.get('/company', {
            headers: {
                'x-tenant-id': id,
            },
        })
    },

    getPublicById(id) {
        return axios.get(`/public-company/${id}`)
    },

    getOffers(id) {
        return axios.get('/company-offer', {
            headers: {
                'x-tenant-id': id,
            },
        })
    },

    createCompany(data) {
        return axios.post('/company', data)
    },

    delete(id) {
        return axios.delete('/company', {
            headers: {
                'x-tenant-id': id,
            },
        })
    },

    uploadMainPhoto({ id, main, avatar }) {
        return axios.post(
            '/photo/company-main-avatar',
            { main, avatar },
            {
                headers: {
                    'x-tenant-id': id,
                },
            },
        )
    },

    updateCompany(data, companyId) {
        return axios.put('/company', data, {
            headers: {
                'x-tenant-id': companyId,
            },
        })
    },

    getCompanyAvailability(companyId) {
        return axios.get('/company-availability', {
            headers: {
                'x-tenant-id': companyId,
            },
        })
    },

    reuseAvailability(request) {
        return axios.post('/company-availability/reuse-availability', request, {
            headers: {
                'x-tenant-id': request.companyId,
            },
        })
    },

    uploadPhotos({ id, files }) {
        return Promise.all(
            files.map((file) => {
                return axios
                    .post(
                        '/photo/company',
                        {
                            photo: file.base64File.split(`,`)[1],
                            type: file.type,
                        },
                        {
                            onUploadProgress: function (progressEvent) {
                                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                                file.progress = percentCompleted
                            },
                            headers: {
                                'x-tenant-id': id,
                            },
                        },
                    )
                    .then((res) => {
                        file.isUploaded = true
                        file.isUploading = false
                        file.file.id = res.id
                    })
                    .catch((error) => {
                        file.isUploading = false
                        file.error = true
                        throw error
                    })
            }),
        )
    },

    removePhoto(id) {
        return axios.delete(`/photo/${id}`)
    },

    setCoverPhoto({ companyId, photoId }) {
        return axios.post(
            `/photo/${photoId}/set-as-company-cover`,
            {},
            {
                headers: {
                    'x-tenant-id': companyId,
                },
            },
        )
    },

    getCompanyTeam(id) {
        return axios.get(`/public-company/team/${id}`)
    },

    getCompanyByDomain(domain) {
        return axios.get(`/public-company/find-by-subdomain/${domain}`)
    },

    getInvoices(id) {
        return axios.get('/company-billing/invoices', {
            headers: {
                'x-tenant-id': id,
            },
        })
    },

    deleteCompany(companyId) {
        return axios.delete('/company', {
            headers: {
                'x-tenant-id': companyId,
            },
        })
    },

    activateCompany(companyId) {
        return axios.put(
            '/company/reactivate',
            {},
            {
                headers: {
                    'x-tenant-id': companyId,
                },
            },
        )
    },

    getCompanyByQrcodeId(id) {
        return axios.get(`/public-company/find-by-qr-code-id/${id}`)
    },

    getAllCompanies() {
        return axios.get(`/company/getAll`)
    },

    getCompanyClients(companyId, filter) {
        return axios.post(`/company/clients`, filter, {
            headers: {
                'x-tenant-id': companyId,
            },
        })
    },

    blockUnblock(id, companyId) {
        return axios.put(
            `company-client/block-unblock/${id}`,
            {},
            {
                headers: {
                    'x-tenant-id': companyId,
                },
            },
        )
    },

    addClient(data, companyId) {
        return axios.post(`/company-client`, data, {
            headers: {
                'x-tenant-id': companyId,
            },
        })
    },

    editClient(data, clientId, companyId) {
        return axios.put(`/company-client/update-company-client/${clientId}`, data, {
            headers: {
                'x-tenant-id': companyId,
            },
        })
    },

    getChartOfferData(companyId, data) {
        return axios.post(`/statistics/company-calendar-events`, data, {
            headers: {
                'x-tenant-id': companyId,
            },
        })
    },

    getChartRevenueData(companyId, data) {
        return axios.post(`/statistics/company-calendar-events-revenue`, data, {
            headers: {
                'x-tenant-id': companyId,
            },
        })
    },

    getCustomReminders(companyId) {
        return axios.get(`/custom-reminder`, {
            headers: {
                'x-tenant-id': companyId,
            },
        })
    },

    createCustomReminders(companyId, data) {
        return axios.post(`/custom-reminder/company`, data, {
            headers: {
                'x-tenant-id': companyId,
            },
        })
    },

    editCustomReminders(companyId, id, data) {
        return axios.put(`/custom-reminder/company/${id}`, data, {
            headers: {
                'x-tenant-id': companyId,
            },
        })
    },

    deleteCustomReminders(companyId, id) {
        return axios.delete(`/custom-reminder/company/${id}`, {
            headers: {
                'x-tenant-id': companyId,
            },
        })
    },

    getCustomReminderStatistic(companyId, body) {
        return axios.post(`/custom-reminder/statistic`, body, {
            headers: {
                'x-tenant-id': companyId,
            },
        })
    },

    getCompanyOutstandingAmount(id) {
        return axios.get('/company-billing/outstanding-amount', {
            headers: {
                'x-tenant-id': id,
            },
        })
    },
}
